export function isDesktopNotificationSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function getDesktopNotificationPermission(): NotificationPermission | 'unsupported' {
  if (!isDesktopNotificationSupported()) return 'unsupported';
  return window.Notification.permission;
}

export async function requestDesktopNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (!isDesktopNotificationSupported()) return 'unsupported';
  try {
    return await window.Notification.requestPermission();
  } catch {
    return window.Notification.permission;
  }
}

export function showDesktopPushNotification(title: string, body: string, options?: { tag?: string; icon?: string }): void {
  if (!isDesktopNotificationSupported()) return;
  if (window.Notification.permission !== 'granted') return;
  const titleTrimmed = title.trim();
  const safeTitle = titleTrimmed.length > 0 ? titleTrimmed : 'Notification';
  const bodyTrimmed = (body ?? '').trim();
  const safeBody = bodyTrimmed.length > 0 ? bodyTrimmed : undefined;
  try {
    const n = new window.Notification(safeTitle, {
      body: safeBody,
      tag: options?.tag ?? 'admin-push',
      icon: options?.icon ?? '/favicon.svg',
      silent: false
    });
    n.onclick = () => {
      window.focus();
      n.close();
    };
  } catch {
    console.error('Failed to show desktop push notification');
  }
}
